import FeatureGate from "@/src/components/feature-gate";
import NewsDetailScreen from "@/src/screens/news/news-detail-screen/news-detail-screen";

export default function NewsDetail() {
  return (
    <FeatureGate feature="news">
      <NewsDetailScreen />
    </FeatureGate>
  );
}
